module.exports = __webpack_public_path__ + "img/college_icon.388e7010.svg";